import { Select } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRouting } from '../../routing/routingProvider';
import { ComponentsDispatch, RootState } from '../../store';
import { setterGant } from '../../store/slices/gantSlice';
import { HeaderType } from '../../types';

const SelectPeriod = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const headerType = useSelector<RootState, HeaderType>((state) => state.gant.headerType);

    const { setUrlParam } = useRouting();
    const handleChange = (value: string) => {
        dispatch(setterGant({ headerType: value as HeaderType }));
        setUrlParam({ period: value });
    };

    return (
        <Select
            value={headerType}
            style={{ width: 120 }}
            onChange={handleChange}
            options={[
                { label: 'Day', value: 'day' },
                { label: 'Week', value: 'week' },
                { label: 'Month', value: 'month' },
                { label: 'Quarter', value: 'quarter' },
                // { label: 'Year', value: 'year' },
            ]}
        />
    );
};

export default SelectPeriod;
